import reframe from 'nike-re-framejs';

reframe.regSub('sub:betbanners/by-bet-number', (db, [_, betNumber]) => db.getIn(['betbanners', betNumber]));
